import { Component } from 'react';
import { cachedCustomers } from '../../config/SiteConfig';
import getCustomersCount from '../../utils/getCustomersCount';

export default class Sold extends Component {
	constructor(props) {
		super(props);

		this.state = {
			customers: cachedCustomers,
		};
	}

	async componentDidMount() {
		try {
			const customersCount = await getCustomersCount();
			this.setState({ customers: this.formatNumber(customersCount, 0) });
		} catch (err) {}
	}

	formatNumber(num) {
		return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
	}

	render() {
		return this.state.customers;
	}
}
